import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ApiModule } from 'papi-client-ng2';

import { Service } from './service';

@NgModule({
	imports: [
		CommonModule,
		HttpClientModule
	],
	providers: [
		Service
	]
})

export class PapiModule {
	constructor(@Optional() @SkipSelf() parentModule: PapiModule) {
		if (parentModule) {
			throw new Error('PapiModule is already loaded. Import it in the AppModule only');
		}
	}

	// static forRoot(config?: {}): ModuleWithProviders {
	// 	return {
	// 		ngModule: PapiModule,
	// 		providers: [
	// 			{provide: ApiModule, useValue: ApiModule }
	// 		]
	// 	};
	// }
}
